import axiosInstance from "../helpers/refreshTokenMiddleware";
import ActionTypes from "../constants/ActionTypes";
import BASE_URL from '../constants/Api';

// Action Creators
export const setCurrentPattern = (pattern) => ({
  type: ActionTypes.SET_CURRENT_PATTERN,
  payload: pattern,
});

export const clearFormData = () => ({
  type: ActionTypes.CLEAR_FORM_DATA,
});

// Register Document Action Creators
export const registerDocumentRequest = () => ({
  type: ActionTypes.REGISTER_DOCUMENT_REQUEST,
});

export const registerDocumentSuccess = (data) => ({
  type: ActionTypes.REGISTER_DOCUMENT_SUCCESS,
  payload: data,
});

export const registerDocumentFailure = (error) => ({
  type: ActionTypes.REGISTER_DOCUMENT_FAILURE,
  payload: error,
});

// Async Actions
export const registerDocument = (requestBody) => async (dispatch) => {
  dispatch(registerDocumentRequest());
  try {
    // API: /top/data-regist
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) {
      window.location.href = '/Login';
      return;
    }

    const response = await axiosInstance.post(
      `${BASE_URL}/top/data-regist`,
      requestBody,
      {
        headers: {
          'Authorization': `Bearer ${accessToken}`,
        },
      }
    );

    const responseData = response?.data || {};
    const statusCode =
      responseData?.status ??
      responseData?.respons?.status ??
      response?.status;

    // バックエンドからのレスポンスを処理
    if (statusCode === 200) {
      const message =
        responseData.respons?.message ||
        responseData.respons?.msg ||
        "登録成功！";
      const payload = { ...responseData, message };
      dispatch(registerDocumentSuccess(payload));
      return { success: true, message, data: responseData };
    } else {
      const message =
        responseData.respons?.message ||
        responseData.respons?.msg ||
        responseData.message ||
        "登録に失敗しました";
      dispatch(registerDocumentFailure(message));
      throw new Error(message);
    }
  } catch (error) {
    //バックエンドからのエラーを処理　（５００）
    const errorMessage = 
      error.response?.data?.respons?.message ||
      error.response?.data?.respons?.msg ||
      error.response?.data?.message || 
      error.message || 
      "500ゲート　登録に失敗しました";
    
    dispatch(registerDocumentFailure(errorMessage));
    throw new Error(errorMessage);
  }
};

